
export const  GlobalService={
  path:'https://glowlineapi.sparklabitservices.com/public/api'

}